import { Link } from "react-router-dom";
import {
  BellIcon,
  CalendarIcon,
  HomeIcon,
  MessageIcon
} from "../icons/AppIcons";
import type { FamilyNavigationCounts } from "./useFamilyNavigationCounts";

export type FamilyBottomNavigationTab = "home" | "schedule" | "communications" | "notifications";

type FamilyBottomNavigationProps = {
  tenantSlug: string;
  activeTab: FamilyBottomNavigationTab;
  counts: FamilyNavigationCounts;
};

function formatBadgeCount(value: number | null): string | null {
  if (value === null || value <= 0) {
    return null;
  }

  if (value >= 100) {
    return "99+";
  }

  return String(value);
}

export function FamilyBottomNavigation({
  tenantSlug,
  activeTab,
  counts
}: FamilyBottomNavigationProps) {
  const items = [
    {
      key: "home" as const,
      label: "ホーム",
      to: `/t/${tenantSlug}/home`,
      icon: <HomeIcon size={24} />,
      badge: formatBadgeCount(counts.home)
    },
    {
      key: "schedule" as const,
      label: "予定",
      to: `/t/${tenantSlug}/my-schedule`,
      icon: <CalendarIcon size={24} />,
      badge: formatBadgeCount(counts.schedule)
    },
    {
      key: "communications" as const,
      label: "連絡",
      to: `/t/${tenantSlug}/member-communications`,
      icon: <MessageIcon size={24} />,
      badge: formatBadgeCount(counts.communications)
    },
    {
      key: "notifications" as const,
      label: "通知",
      to: `/t/${tenantSlug}/notifications`,
      icon: <BellIcon size={24} />,
      badge: formatBadgeCount(counts.notifications)
    }
  ];

  return (
    <nav className="family-bottom-nav" aria-label="家族向けページナビゲーション">
      <div className="family-bottom-nav__list">
        {items.map((item) => (
          <Link
            key={item.key}
            to={item.to}
            className="family-bottom-nav__item"
            aria-current={activeTab === item.key ? "page" : undefined}
          >
            <span className="family-bottom-nav__icon-wrap">
              {item.icon}
              {item.badge ? <span className="family-bottom-nav__badge">{item.badge}</span> : null}
            </span>
            <span className="family-bottom-nav__label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
